import { OrderConsultationRequest } from '@/storage/gateways/TariffGateway';

/**
 * @description Время показа уведомления об успешно отправленной заявке.
 * @type {number}
 */
const SHOW_SUCCESS_NOTIFICATION_TIMEOUT = 3000;

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.orderConsultationViolations ? vm.orderConsultationViolations[cause] : []
);

/**
 * @description Смешиваемый объект для работы с заявкой на консультацию.
 */
export default {
  data() {
    return {
      /**
       * @description Ожидание завершения запроса.
       * @type {boolean}
       */
      isOrderConsultationAwaitRequest: false,
      /**
       * @description Нарушения ограничений.
       * @type {any}
       */
      orderConsultationViolations: {},
      /**
       * @description Показывать форму.
       * @type {boolean}
       */
      isShowOrderConsultationForm: false,
      /**
       * @description Заявка отправлена.
       * @type {boolean}
       */
      isOrderSended: false,
      /**
       * @description Сообщение о заявке на консультацию.
       * @type {string}
       */
      orderConsultationMessage: '',
      /**
       * @description ФИО.
       * @type {string}
       */
      orderConsultationFullName: '',
      /**
       * @description Телефон.
       * @type {string}
       */
      orderConsultationPhone: '',
    };
  },
  computed: {
    orderConsultationFullNameViolations: resolveInputErrors('full-name'),
    orderConsultationPhoneViolations: resolveInputErrors('phone'),
    /**
     * @description Заголовок диалога заказа консультации.
     * @type {string}
     */
    orderConsultationTitle() {
      if (this.isOrderSended) {
        return '';
      }
      return 'Заполните данные, и наш менеджер свяжется с вами в ближайшее время';
    },
    /**
     * @description Деактивировать кнопку отправки.
     * @type {boolean}
     */
    disableOrderConsultationButton() {
      return this.isOrderConsultationAwaitRequest;
    },
  },
  methods: {
    /**
     * @description Обработать отправку запроса на консультацию.
     * @returns {void}
     */
    onSubmitOrderConsultation() {
      const request = new OrderConsultationRequest(
        this.orderConsultationFullName,
        this.orderConsultationPhone,
      );
      this.isOrderConsultationAwaitRequest = true;
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
        this.orderConsultationViolations = error.allCauses();
      };
      const onSuccess = (message) => {
        this.notifySuccess(message);
        this.refreshSupportFields();
        this.orderConsultationMessage = message;
        setTimeout(
          () => {
            this.isShowOrderConsultationForm = false;
          },
          SHOW_SUCCESS_NOTIFICATION_TIMEOUT,
        );
      };
      this
        .$tariffGateway
        .orderConsultation(request)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => {
          this.isOrderConsultationAwaitRequest = false;
        });
    },
    /**
     * @description Обновить поля формы.
     * @returns {void}
     */
    refreshSupportFields() {
      this.orderConsultationFullName = '';
      this.orderConsultationPhone = '';
      this.orderConsultationViolations = {};
      this.isOrderSended = true;
    },
  },
};
